import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const ShoppingApi = createApi({
    reducerPath : "ShoppingApi" ,
    baseQuery : fetchBaseQuery({
        baseUrl : import.meta.env.VITE_API + 'shopping_guide' ,
        prepareHeaders : (headers) => {
            headers.set("Content-Type" , "application/json")
            return headers
        }
    }),
    endpoints : (builder) => ({
        getShoppingGuide : builder.query({
            query : () => ({
                url : "" ,
                method : "GET"
            })
        }) 
    })
}) 
export const { useGetShoppingGuideQuery } = ShoppingApi